// DebugViewer.tsx
import React from "react";
import { Box, Flex, Title, SegmentedControl, Text, Button } from "@mantine/core";
import { useAppDispatch } from "../app/hooks"; // Antag att du har hooks

// Dina två komponenter
import { clearDebugMcBimItemsInRedux, clearThreeDItemsInRedux } from "./DebugSlice";
import { Debug3d } from "./3d/Debug3d";
import { Debug2dFloorplan } from "./2dFloorplan/Debug2dFloorPlan";

type Props = {
  onLoad?: (json: unknown) => void;
};

export const DebugViewer: React.FC<Props> = ({ onLoad }) => {
  const dispatch = useAppDispatch();
  const [mode, setMode] = React.useState<"2d" | "3d">(() => {
    const saved = localStorage.getItem("debugViewerMode");
    return saved === "3d" ? "3d" : "2d";
  });

  React.useEffect(() => {
    localStorage.setItem("debugViewerMode", mode);
  }, [mode]);

  const handleClearData = () => {
    dispatch(clearDebugMcBimItemsInRedux());
    dispatch(clearThreeDItemsInRedux());
    localStorage.removeItem("debugState"); // Rensa localStorage-key
  };

  return (
    <Box h="100%" display="flex" style={{ flexDirection: "column" }}>
      {/* Header med titel + switch */}
      <Flex p="md" justify="space-between" align="center" style={{ flexShrink: 0 }}>
        <Title order={3}>Debug Viewer</Title>

        <Flex gap="sm" align="center">
          <SegmentedControl
            value={mode}
            onChange={(value) => setMode(value as "2d" | "3d")}
            data={[
              { label: "2D (Polygoner)", value: "2d" },
              { label: "3D (IFC)", value: "3d" },
            ]}
            color="blue"
            size="md"
          />
          <Button variant="outline" color="red" size="md" onClick={handleClearData}>
            Rensa data
          </Button>
        </Flex>
      </Flex>

      {/* Huvudinnehåll – fyller resten av höjden */}
      <Box h="100%" style={{ flex: 1, minHeight: 0, position: "relative" }}>
        {mode === "2d" ? <Debug2dFloorplan onLoad={onLoad} /> : <Debug3d />}
      </Box>

      {/* Valbar footer med info */}
      <Box
        p="xs"
        style={{
          background: "var(--mantine-color-gray-1)",
          fontSize: "0.8rem",
          textAlign: "center",
        }}
      >
        <Text c="dimmed">
          {mode === "2d" ? "Släpp en .json-fil med 2D-data" : "Släpp en .ifc-fil för 3D-visning"}
        </Text>
      </Box>
    </Box>
  );
};
